(function () {
    // =====================================
    // MARK JS READY (for defer flash)
    // =====================================
    document.documentElement.classList.add('js-ready');


    // =========================
    // DOT PROGRESS FUNCTION
    // =========================
    function startDotProgress($slider, index, speed) {

      const $dots = $slider.find('.slick-dots li');

      $dots.each(function () {
        const $circle = $(this).find('circle');

        $circle.css({
          transition: 'none',
          strokeDashoffset: 100
        });
      });

      const $activeDot = $dots.eq(index);
      const $circle = $activeDot.find('circle');

      if (!$circle.length) return;

      $circle[0].offsetHeight;

      $circle.css({
        transition: `stroke-dashoffset ${speed}ms linear`,
        strokeDashoffset: 0
      });
    }

    function runImageZoom($scope, slick) {

      // Remove previous animations
      $('.slide__img img').removeClass('zoomInImage zoomOutImage');

      // Current slide image
      const $img = $scope.find('.slide__img img');

      if (!$img.length) return;

      // Match animation duration with autoplay
      const duration = (slick.options.autoplaySpeed || 3000) * 0.4; // 🔥 faster zoom

      $img.css('animation-duration', duration + 'ms');

      // Apply zoom effect
      $img.addClass('zoomInImage');

    }


    // =========================
    // ANIMATION FUNCTION
    // =========================
    function runAnimations($scope) {

      $('[data-animation-in]').each(function () {
        const $el = $(this);

        $el.removeClass(function (index, className) {
          return (className.match(/animate__\S+/g) || []).join(' ');
        });

        $el.css({
          opacity: 0,
          animationDelay: ''
        });
      });

      $scope.find('[data-animation-in]').each(function () {

        const $el = $(this);
        const animation = $el.data('animation-in') || 'fadeInUp';
        const delay = parseFloat($el.data('delay-in')) || 0;

        $el.css({
          animationDelay: delay + 's'
        });

        setTimeout(() => {
          $el.addClass('animate__animated animate__' + animation)
            .css('opacity', 1);
        }, 50);

      });

    }


    // =========================
    // INIT FUNCTION
    // =========================
    function initSlider($scope) {

      const $sliders = $scope.find('.slider');

      $sliders.each(function () {

        const $this = $(this);

        // DO NOT UNSLICK — just skip if already initialized
        if ($this.hasClass('slick-initialized')) {
          return;
        }

        const autoplay = String($this.data('autoplay')) === 'true';
        let autoplaySpeed = parseInt($this.data('autoplay-timeout')) || 3000;
        const loop = String($this.data('loop')) === 'true';
        const arrows = String($this.data('nav')) === 'true';
        const dots = String($this.data('dots')) === 'true';
        const rtl = String($this.data('rtl')) === 'true';
        const speed = parseInt($this.data('speed')) || 800;

        // Disable autoplay in editor (prevents flicker)
        if (window.Shopify && Shopify.designMode) {
          autoplaySpeed = 999999;
        }

        // Clean old events
        $this.off('init afterChange beforeChange');

        $this.on('init', function (event, slick) {

          const $firstSlide = $(slick.$slides[0]);
          runAnimations($firstSlide);
          runImageZoom($firstSlide, slick);

          // Inject SVG dots
          $this.find('.slick-dots li').each(function () {
            $(this).html(`
              <button>
                <svg class="progress-ring" width="30" height="30">
                  <circle cx="15" cy="15" r="14"></circle>
                </svg>
              </button>
            `);
          });

          startDotProgress($this, 0, slick.options.autoplaySpeed);
        });

        $this.on('afterChange', function (event, slick, currentSlide) {
          const $currentSlide = $(slick.$slides[currentSlide]);
          runAnimations($currentSlide);
          runImageZoom($currentSlide, slick);
        });

        $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          startDotProgress($this, nextSlide, slick.options.autoplaySpeed);
        });

        // small delay ensures DOM ready in editor
        setTimeout(() => {
          $this.slick({
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            infinite: loop,
            speed: speed,
            rtl: rtl,
            lazyLoad: 'progressive',
            arrows: arrows,
            dots: dots,

            fade: true,
            cssEase: 'linear',

            prevArrow: `
              <button class="slick-nav prev-arrow scroll-btn scroll-btn--left shadow-sm glass-effect" aria-label="Previous">
                <svg class="icon icon-caret w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"></path>
                </svg>
              </button>
            `,
            nextArrow: `
              <button class="slick-nav next-arrow scroll-btn scroll-btn--right shadow-sm glass-effect" aria-label="Next">
                <svg class="icon icon-caret w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"></path>
                </svg>
              </button>
            `
          });
        }, 50);

      });

    }


    // =========================
    // LOAD HANDLING
    // =========================

    // First load
    $(document).ready(function () {
      initSlider($(document));
    });

    // Shopify editor (section reload)
    document.addEventListener('shopify:section:load', function (e) {
      initSlider($(e.target));
    });

    // Reorder
    document.addEventListener('shopify:section:reorder', function (e) {
      initSlider($(e.target));
    });


    // =========================
    // ARROW CLICK ANIMATION
    // =========================
    $(document).on('click touch', '.slick-nav', function () {

      let arrow = $(this);

      if (!arrow.hasClass('animate')) {
        arrow.addClass('animate');
        setTimeout(() => {
          arrow.removeClass('animate');
        }, 1600);
      }

    });

})();